import styled from 'styled-components';

interface ContainerProps {
  size: number;
  color: string;
}

export const Container = styled.span<ContainerProps>`
  font-family: 'Material Symbols Outlined';
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  display: inline-block;
  user-select: none;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;

  font-size: ${({ size }) => size}px;
  color: ${({ color }) => color};
`;
